import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  EstadoComponente,
} from "@/shared/components/ui";
import {
  useFetchSolicitudesEgreso,
} from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  EstadosSolicitudPeodidoEnum,
  MaterialTransferido,
} from "@/shared/interfaces";
import { Button, Grid, } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useState, useMemo } from "react";

import VisibilityIcon from '@mui/icons-material/Visibility';
import { PermissionsEnum } from "@/auth/interfaces";
import { cellNotFilter, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from "@/shared";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";

type DetalleUsuarios = {
  id?: number;
  estado_solicitud?: string;
  motivo_rechazo_data?: {
    nombre?: string
  },
  observaciones?: {
    observacionRevisionSolicitudPedido?: string;
  }
};

export default function SolicitudPedidosUsuariosRechazadosPagina() {
  useCheckPermissions(PermissionsEnum.api_view_solicitudegreso);
  //**STORE*/
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const paginationTable = useCargarSeriesProductos(s => s.pagination)
  const setPaginationTable = useCargarSeriesProductos(s => s.setPagination)
  //** */
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [details, setDetails] = useState<IDataProducto[]>([]);

  const columns = useMemo<MRT_ColumnDef<DetalleUsuarios>[]>(
    () => [
      {
        ...cellNotFilter,
        accessorKey: "detalles",
        header: "producto",
        size: 20,
        width: 20,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={() => {
                onDetails(row.original);
              }}
            >
              {'Ver'}
            </Button>
          );
        },
      },
      {
        accessorKey: "numero_referencia",
        header: "N° solicitud",
        size: 200,
        width: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "usuario",
        size: 100,
        width: 100,
        //Cell: ({ row }) => row.original?.user?.username || 'N/A'
      },
      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
        //Cell: ({ row }) => row.original?.bodega_data?.nombre || 'N/A'
      },
      {
        accessorKey: "motivo_rechazo_data.nombre",
        header: "Motivo Rechazo",
        size: 200,
        Cell: ({ row }) => row.original.motivo_rechazo_data?.nombre || 'N/A'
      },
      {
        accessorKey: 'observaciones.observacionRevisionSolicitudPedido',
        header: "Observacion del Revisor",
        size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_MEDIUM,
        Cell: ({ row }) => {
          return <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
            }
            title="observación"
          />
        }
        //Cell:({row}) => row.original.observaciones?.observacionRevisionSolicitudPedido || 'N/A'
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "Fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor="red" texto={row.original.estado_solicitud || ''} /> : null
        ),
      },
    ],

    []
  );

  const onDetails = (e: MRT_RowData) => {
    const productos = e.trazabilidades_rechazadas?.map((item:any) =>{
      return{
        id:item.producto_data?.id,
        cantidad:item.producto_data?.cantidad,
        codigo:item.producto_data?.codigo,
        cantidad_aprobada:item.producto_data?.cantidad_aprobada,
        contiene_serie:item.producto_data?.contiene_serie,
        producto_data:{
          descripcion: item.producto_data?.producto_data?.descripcion,
          modelo_producto: item.producto_data?.producto_data?.modelo_producto,
          marca_producto: item.producto_data?.producto_data?.marca_producto,
          categoria_producto: item.producto_data?.producto_data?.categoria_producto,
          unidad_medida: item.producto_data?.producto_data?.unidad_medida
        }

      }

    })
    handleCopiarLista(productos)
    setIsModalOpen(true);
  };
  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] =
    useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',

        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',

        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
          Cell: ({ row }) => row.original?.producto_data?.modelo_producto || 'N/A'
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
          Cell: ({ row }) => row.original?.producto_data?.marca_producto || 'N/A'
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
          Cell: ({ row }) => row.original?.producto_data?.categoria_producto || 'N/A'
        },

        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Unidad Medida',
          Cell: ({ row }) => row.original?.producto_data?.unidad_medida || 'N/A'
        },
      ],
      []
    );

  const {
    pagination,
    searchTerm,
    setPagination,
    dateBefore,
    dateAfter,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering()

  const {
    data: solicitudPedidosRechazadosRes,
    isLoading: isLoadingSolicitudesPedidoPaging,
    isRefetching,
  } = useFetchSolicitudesEgreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.RECHAZADO,
    tiene_trazabilidad_rechazada: true,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
    ...filterObject,
  });



  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
      </Grid>
      <Grid item xs={12}>
        <GeneralTable
          columns={columns}
          data={solicitudPedidosRechazadosRes?.data.data || []}
          isLoading={isLoadingSolicitudesPedidoPaging}
          isRefetching={isRefetching}
          enableGlobalFilter={false}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidosRechazadosRes?.data.count}
          actionsColumnSize={120}
          ///
          enableManualFiltering={true}
          enableSorting={false}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          // crud
          enableColumnActions={true}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Productos"
        onCloseIcon={() => setIsModalOpen(false)}
        minWidth="60%"
        contentNode={
          <Grid container spacing={3}>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <SampleTablePagination
                columns={columnsProductosDetallePedidosDb}
                data={paginatedData}
                rowCount={productos.length}
                pagination={paginationTable}
                setPagination={setPaginationTable}
                rowNumber={true}
              />
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
}
